var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2856 4.57148H19.4285C20.6909 4.57148 21.7142 5.59483 21.7142 6.8572V18.2858C21.7142 19.5481 20.6909 20.5715 19.4285 20.5715H4.57136C3.30899 20.5715 2.28564 19.5481 2.28564 18.2858V6.8572C2.28564 5.59483 3.30899 4.57148 4.57136 4.57148H5.71422V4.00005C5.71422 3.05328 6.48173 2.28577 7.4285 2.28577C8.37528 2.28577 9.14279 3.05328 9.14279 4.00005V4.57148H14.8571V4.00005C14.8571 3.05328 15.6246 2.28577 16.5714 2.28577C17.5181 2.28577 18.2856 3.05328 18.2856 4.00005V4.57148ZM5.4285 9.14291C4.95511 9.14291 4.57136 9.52667 4.57136 10.0001C4.57136 10.4734 4.95511 10.8572 5.4285 10.8572H18.5714C19.0447 10.8572 19.4285 10.4734 19.4285 10.0001C19.4285 9.52667 19.0447 9.14291 18.5714 9.14291H5.4285Z",
    fill: "#482701"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.aaae72474feaa7c6da6f443720cb83a4.svg";
export { ForwardRef as ReactComponent };